import {useState, useEffect} from "react";
import { Form, Input, Button, message, DatePicker, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {  postAPI } from "../../../config/api/apiConfig";
import { setIsDeviceApproved } from "../../../redux/feature/device";
import moment from "moment-timezone";

const ApproveDevicereport = ({
  reportId,
  deviceId,
  getReportref
}) => {
  const [deviceFileType, setDeviceFileTyple] = useState(null);
  const [existDaviceId, setExistDaviceId] = useState(null);

  const dispatch = useDispatch();

  // const getReport = async () => {
  //   const reportes = await getAPI(`/list-device-report`);
  //   const { data } = reportes.data;
  //   setDeviceFileTyple(data[0]?.deviceReportPaths[0]?.toString().split("/")[3])
  //   setExistDaviceId(data[0].deviceId)
  //   console.log("DAta", data[0])

  // };


  const addApproval = async (values, reportId) => {
    if (values.startDate) {
      // Convert to 'Africa/Lagos' timezone keeping the same date selected by user
      values.startDate = moment.tz(values.startDate.format('YYYY-MM-DD HH:mm:ss'), "Africa/Lagos").valueOf();
    }
    
    console.log("VALUES", values);
    const url = `/approve-report`;
    try {
      const approval = await postAPI(url, values);
      const { success } = approval.data;
      if (success) {
        dispatch(setIsDeviceApproved(success));
        message.success("Device approval was successful");
        form.resetFields();
        getReportref();
      }
    } catch (err) {
      message.error(err.response?.data?.message);
      console.log(err);
      form.resetFields();
    }
  };
  
  const [form] = Form.useForm();
  const userId = useSelector((state) => state.authenticate.userId);
  return (
    <Form form={form} onFinish={addApproval} layout="vertical">
      <Row justify="center">
        <Col span={12}> 
          <Form.Item label="Admin Remark" name="superAdminRemarks"  >
            <Input.TextArea
              placeholder="Add remark"
              showCount
              maxLength={150}
              rows={4}
              cols={60} 
            />
          </Form.Item>
          <Form.Item label="Start Date" name="startDate">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name="deviceReportId"
            style={{ display: "none" }}
            value={reportId}
            initialValue={reportId}
          >
            <Input defaultValue={reportId} />
          </Form.Item>
          <Form.Item
            name="certifiedBy"
            style={{ display: "none" }}
            value={userId}
            initialValue={userId}
          >
            <Input defaultValue={userId} />
          </Form.Item>
          <Form.Item
            name="userDeviceId"
            style={{ display: "none" }}
            value={parseInt(deviceId)}
            initialValue={parseInt(deviceId)}
          >
            <Input defaultValue={parseInt(deviceId)} />
          </Form.Item>
          <Form.Item
            name="status"
            style={{ display: "none" }}
            value="approved"
            initialValue="approved"
          >
            <Input defaultValue="approved" />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              span: 24,
            }}
            style={{
              marginTop: 20,
              textAlign: "center",
            }}
          >
            <Button type="primary" htmlType="submit">
              Approve Device
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default ApproveDevicereport;
